import { useContext } from 'react';

import { CustomStylesCtx } from '@webapp/common/components/custom-styles';
import { setHtml } from '@webapp/common/lib/ui';

import { selectRetryNotAllowedMessage } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

export const RetryNotAllowedMessage: FC = () => {
    const {
        question: { text: questionTextStyles },
    } = useContext(CustomStylesCtx);
    const text = useStateSelector(selectRetryNotAllowedMessage);

    return <div data-testid='retry-not-allowed-message' {...setHtml(text)} style={questionTextStyles} />;
};
